import React, { useMemo } from 'react';
import NavigationHeader from '../../../../components/navigation/navigation-header';
import Flex from '../../../../components/surfaces/flex';
import Page from '../../../../components/surfaces/page';
import COLORS from '../../../../constants/colors';
import { tKeys } from '../../../../translations/keys';
import DocumentList from '../components/list/document-list/index.web';
import useLogic from './logic.web';
import Tabs from '../../../../components/navigation/tabs';
import Tab from '../../../../components/navigation/tabs/tab';
import Container from '../../../../components/surfaces/container';
import ButtonAddDocument from '../components/input/button-add-document';
import CreateDocument from './create-document/index.web';
import { Button, HStack, Box, Input } from '@chakra-ui/react';
import FilterSelect from './filter-select/index.web';
import Icon from '../../../../components/content/icon';
import { FilterDate } from './filter-date/index.web';
import styles from './style.web';
import { DocumentRelation, } from '../../../../services/types';
import { useTranslation } from 'react-i18next';
import { useCompaniesContext } from '../../../../contexts/companies';
import EventTypeList from './event-type-list/index.web';
const Repository = () => {
    // Attributes
    const { t } = useTranslation();
    const { selectedCompanyId, selectedEnrolment } = useCompaniesContext();
    const { optionsGroupBy, handleOnPressTab, selectedTab, selectedRepositoryFilters, handleOnPressAddDocument, documentsData, isDocumentDataLoading, isDropdownOpen, listLayoutType, onDocumentPress, onLayoutIconPress, optionsOrder, refetchDocumentData, setDropdownOpen, isOpenCreateDocument, onCloseCreateDocument, selectedFile, refetchDocuments, canUploadDocument, setOrderBy, orderBy, documentTypeOptions, documentSources, handleOnDocumentTypeFilterChange, handleOnDocumentRelationChange, handleOnSetFromDateChange, fromDate, onToggleFromPopOver, isFromPopoverOpen, handleOnSetToDateChange, toDate, onToggleToPopOver, isToPopoverOpen, handleOnGroupByChange, selectedOptionGroupBy, selectedDocumentRelation, selectedDocumentTypes, searchTerm, setSearchTerm, } = useLogic();
    // Frontend grouping logic when 'From Event' is selected
    const groupedEventData = useMemo(() => {
        if (selectedDocumentRelation?.value === DocumentRelation[1] &&
            documentsData) {
            const nestedData = {};
            documentsData.forEach(category => {
                const eventType = category.categoryName || 'Uncategorized Events';
                if (!nestedData[eventType]) {
                    nestedData[eventType] = {};
                }
                category.items?.forEach(doc => {
                    // Ensure 'doc' is treated as ApiDocument
                    const apiDoc = doc;
                    const eventTitle = apiDoc.eventTitle || `Event ID: ${apiDoc.eventId || 'Unknown'}`;
                    if (!nestedData[eventType][eventTitle]) {
                        nestedData[eventType][eventTitle] = [];
                    }
                    nestedData[eventType][eventTitle].push(apiDoc);
                });
            });
            return nestedData;
        }
        return null;
    }, [selectedDocumentRelation, documentsData]);
    // Transform data for DocumentList component when not on 'From Event' tab
    const documentListFormattedData = useMemo(() => {
        if (selectedDocumentRelation?.value !== DocumentRelation[1] &&
            documentsData) {
            return documentsData.map(category => ({
                title: category.categoryName || 'Uncategorized',
                data: category.items || [],
            }));
        }
        return [];
    }, [selectedDocumentRelation, documentsData]);
    // Adjust onDocumentPress type if necessary (check DocumentList component definition)
    const handleDocumentPress = (document) => {
        if ('eventId' in document) {
            onDocumentPress(document);
        }
    };
    return (<Page barStyle="dark-content" backgroundColor={COLORS.White.T500.value} showSideBar>
      <NavigationHeader style={{ zIndex: 900, minHeight: '3.75rem' }} justifyTitle={'flex-start'} endEnhancer={<Flex spacing={20} align="center">
            {canUploadDocument && (<ButtonAddDocument onClickButtonAddDocument={handleOnPressAddDocument}/>)}
          </Flex>}>
        {t(tKeys.common.repository)}
      </NavigationHeader>
      <Container style={styles.tabsContainer}>
        <Tabs activeKey={selectedTab} onChange={activeKey => handleOnPressTab(activeKey)}>
          <Tab title={t(tKeys.filter.document_source.from_event)} onSelect={() => {
            handleOnDocumentRelationChange(documentSources[0]);
        }}/>
          <Tab title={t(tKeys.filter.document_source.general_documents)} onSelect={() => {
            handleOnDocumentRelationChange(documentSources[1]);
        }}/>
          <Tab title={t(tKeys.filter.document_source.to_sign)} onSelect={() => {
            handleOnDocumentRelationChange(documentSources[2]);
        }}/>
        </Tabs>
      </Container>
      <HStack width={'100%'} wrap={'wrap'} spacing={4} alignItems="center" align="normal" p={4} backgroundColor={'#f8f9fc'} style={{ paddingLeft: '2rem' }}>
        {/* Remove the Group By filter entirely */}
        {/* {selectedDocumentRelation?.value === DocumentRelation[3] && (
          <FilterSelect
            options={optionsGroupBy}
            placeholder={t(tKeys.common['group-by'])}
            onChange={handleOnGroupByChange}
            isMulti={false}
            value={selectedOptionGroupBy}
          />
        )} */}
        <Input placeholder="Search by document title..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} flex={1} minWidth="200px" marginRight={2}/>
        <FilterSelect options={documentTypeOptions} placeholder={t(tKeys.common.document_types)} onChange={handleOnDocumentTypeFilterChange} isMulti={true} value={selectedDocumentTypes}/>
        <FilterDate date={fromDate} handleOnDateChange={handleOnSetFromDateChange} togglePopover={isFromPopoverOpen} onTogglePopOver={onToggleFromPopOver} textDate={t(tKeys.common.from)}/>

        <FilterDate date={toDate} handleOnDateChange={handleOnSetToDateChange} togglePopover={isToPopoverOpen} onTogglePopOver={onToggleToPopOver} textDate={t(tKeys.common.to)}/>

        <Button variant="link" colorScheme="blue" size="sm" onClick={() => {
            handleOnSetFromDateChange(null);
            handleOnSetToDateChange(null);
            handleOnDocumentTypeFilterChange([]);
            if (selectedDocumentRelation?.value !== DocumentRelation[1]) {
                handleOnGroupByChange(optionsGroupBy[0]);
            }
        }} leftIcon={<Icon name="close-cross" width={12} height={12} fill={COLORS.Govrn.Blue.T500.value}/>} alignSelf="center">
          {t(tKeys.common['reset-filter'])}
        </Button>
      </HStack>

      {/* Main content */}
      {selectedDocumentRelation?.value === DocumentRelation[1] ? (<Box overflowY="auto" flex={1} width="100%">
          <EventTypeList data={groupedEventData} onDocumentPress={handleDocumentPress}/>
        </Box>) : (<DocumentList kind="document" documentsData={documentListFormattedData} isDocumentDataLoading={isDocumentDataLoading} listLayoutType={listLayoutType} onDocumentPress={handleDocumentPress} onLayoutIconPress={onLayoutIconPress} optionsOrder={optionsOrder} refetchDocumentData={refetchDocumentData} setOrderBy={setOrderBy} selectedDocumentRelation={selectedDocumentRelation} orderBy={orderBy}/>)}
      {/* Modal */}
      <CreateDocument isOpen={isOpenCreateDocument} onClose={onCloseCreateDocument} selectedFile={selectedFile} refetchDocuments={refetchDocuments}/>
    </Page>);
};
export default Repository;
